import { MessageCircle, Hammer } from "lucide-react";
import { HANDMADE_SOAPS, IMAGES } from "../lib/data";
import { useContact } from "../contexts/ContactContext";

export const HandmadeSoaps = () => {
  const { openGate } = useContact();
  
  return (
    <section
      id="handmade"
      data-testid="handmade-section"
      className="section-pad bg-gradient-to-b from-[#FAFAF9] to-white"
    >
      <div className="msc-container">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="relative order-2 lg:order-1">
            <div className="absolute -top-4 -left-4 w-24 h-24 rounded-2xl bg-[#F59E0B]/30 -z-10" />
            <div className="absolute -bottom-4 -right-4 w-32 h-32 rounded-2xl bg-[#1E3A8A]/10 -z-10" />
            <img
              src={IMAGES.handmade}
              alt="Handmade Kala, Peela, Hara, White Sabun"
              loading="lazy"
              className="rounded-2xl shadow-xl w-full object-cover aspect-[4/5]"
              data-testid="handmade-hero-image"
            />
            <div className="absolute top-4 left-4 bg-white/95 backdrop-blur rounded-full px-4 py-2 shadow-lg flex items-center gap-2">
              <Hammer className="w-4 h-4 text-[#D97706]" />
              <span className="font-display font-bold text-xs uppercase tracking-wider text-[#1F2937]">
                Hand-crafted Locally
              </span>
            </div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2">
            <span className="badge-trust">Hamari USP · Speciality</span>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-[#1F2937] leading-tight">
              Handmade Sabun —
              <br />
              <span className="text-[#1E3A8A]">Asli Mehnat,</span>{" "}
              <span className="text-[#D97706]">Asli Daam.</span>
            </h2>
            <p className="mt-4 text-base sm:text-lg text-[#4B5563] max-w-xl">
              Hamari dukaan ki pehchaan — paanch tarah ke handmade sabun, jo
              hum khud banate hain. Bartan se le kar kapde, har kaam ke liye
              ek alag sabun. Kemikal nahi, sirf tajurba.
            </p>

            <div className="mt-5 p-4 bg-[#F59E0B]/10 rounded-xl border border-[#F59E0B]/30 flex items-start gap-3">
              <span className="text-2xl">🎉</span>
              <div>
                <h4 className="font-display font-bold text-[#B45309]">Saturday Tradition!</h4>
                <p className="text-sm text-[#92400E] mt-1 leading-snug">
                  Har Saturday main branch par, humare in-house manufactured soaps (Kala, Peela, Hara) par <b>₹2 se ₹5 per kg ka discount</b> milta hai — retail customers ko seedha wholesale rate!
                </p>
              </div>
            </div>

            {/* Soap chips */}
            <div className="mt-7 grid sm:grid-cols-2 gap-3">
              {HANDMADE_SOAPS.map((s, i) => (
                <div
                  key={s.name}
                  data-testid={`handmade-soap-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className="card-base p-4 flex items-start gap-3 group"
                >
                  <div
                    aria-hidden="true"
                    className="shrink-0 w-12 h-12 rounded-lg shadow-inner border border-black/5 flex items-center justify-center font-display font-black text-xs"
                    style={{ backgroundColor: s.color, color: s.textColor }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-display font-bold text-[#1F2937]">
                        {s.name}
                      </span>
                      <span className="text-[10px] font-bold uppercase tracking-wider text-[#B45309] bg-[#F59E0B]/15 px-2 py-0.5 rounded-full">
                        {s.badge}
                      </span>
                    </div>
                    <p className="text-sm text-[#4B5563] mt-1 leading-snug">
                      {s.use}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-7">
              <button
                onClick={() => openGate("Hello! Mujhe handmade soaps (Kala/Peela/Hara/White/Moam Sabun) ke daam aur availability chahiye.")}
                data-testid="handmade-whatsapp-btn"
                className="btn-whatsapp"
              >
                <MessageCircle className="w-5 h-5" /> Sabun ki Rate Pucho
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
